import { useCallback, useEffect, useState } from 'react'

function useIsMobile(breakpoint = 767) {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined)

  const getIsMobile = useCallback(() => {
    if (typeof window === 'undefined') return undefined
    return window.innerWidth <= breakpoint
  }, [breakpoint])

  useEffect(() => {
    // Set initial value
    setIsMobile(getIsMobile())

    // Debounced resize handler
    let timeoutId: NodeJS.Timeout
    const handleResize = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        setIsMobile(getIsMobile())
      }, 150) // debounce time
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      clearTimeout(timeoutId)
    }
  }, [getIsMobile])

  return isMobile ?? undefined // fallback to false during SSR
}

export default useIsMobile
